import { Col, Collapse, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd';
import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';

import ClearFilterBtn from '../../../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../../../components/CollapseFilter';
import FilterBtn from '../../../../../../components/FilterBtn';
import FilterContainer from '../../../../../../components/FilterContainer';
import { SelectParceiro } from '../../../../../../components/_REFACTORED/SelectParceiro';
import { SelectTransportadoraParceira } from '../../../../../../components/_REFACTORED/SelectTransportadoraParceira';
import TextFilter from '../../../../../../components/TextFilter';
import CollapseTitle from '../../../../../../components/TitleCollapseFilter';
import { ApplicationState } from '../../../../../../store';
import {
  cleanStateAgem,
  filterAgendamentos,
  loadRequest,
} from '../../../../../../store/ducks/agendamentos/actions';
import { CALENDAR_LOCALE } from '../../../../../../utils/calendar-locale';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Panel } = Collapse;

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector(
    (state: ApplicationState) => state.Agendamentos.pagination.current
  );
  const filter = useSelector((state: ApplicationState) => state.Agendamentos.filter);
  const sorter = useSelector((state: ApplicationState) => state.Agendamentos.sorter);
  const insc = useSelector((state: ApplicationState) => state.auth.user);
  const dispatch = useDispatch<Dispatch<Action>>();

  const onFilter = (values: any) => {

    let [dataInicio, dataFim] = values.dhAgendamento
      ? values.dhAgendamento
      : [undefined, undefined];

    if (values.dhAgendamento) {
      dataInicio = moment(dataInicio).format();
      dataFim = moment(dataFim).format();

      values = { ...values, dataInicio, dataFim };
    }

    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });

    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({ ...filter, ...values })
    );

    dispatch(filterAgendamentos({ ...filter, ...values }));
  };

  const clearFilter = () => {
    localStorage.removeItem(`responseTransportadorasFilter${window.location.pathname}`);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(cleanStateAgem());
    dispatch(loadRequest(undefined, inscricaoAtiva, cddAtivo?.codCdd));
  };

  const cdd: any = insc?.centroDistribuicao;

  var group_values = cdd.reduce(function (objT: any, itemAge: any) {
    objT[itemAge.codEmp] = objT[itemAge.codEmp] || [];
    objT[itemAge.codEmp].push({
      codEmp: itemAge.codEmp,
      centroDistribuicao: itemAge.centroDistribuicao,
      nomeFantasia: itemAge.nomeFantasia,
    });
    return objT;
  }, {});

  var group = Object.keys(group_values).map(function (key) {
    return { codEmp: key, data: group_values[key] };
  });

  const children = [];
  children.push(
    group.map((cd) => (
      <Option value={cd.codEmp} key={cd.codEmp}>
        {cd.data[0].codEmp + ' - ' + cd.data[0].nomeFantasia}
      </Option>
    ))
  );

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterAgendamentos}
      saveLocalStorage={'persist:Agendamentos'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Tipo WMS</TextFilter>} name="tipoWms">
                <Select placeholder="Selecione o tipo WMS">
                  <Option value="EXP">Coleta</Option>
                  <Option value="REC">Entrega</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>N° agendamento</TextFilter>} name="codAgendamento">
                <InputNumber
                  min={0}
                  type="number"
                  style={{ width: '100%' }}
                  placeholder="Digite o número do agendamento"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>N° Ordem de carga</TextFilter>} name="ordemCarga">
                <InputNumber
                  min={0}
                  type="number"
                  style={{ width: '100%' }}
                  placeholder="Digite o número da ordem de carga"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Status</TextFilter>} name="status">
                <Select
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placeholder="Selecione o status"
                >
                  <Option value={'AGE'}>Agendado</Option>
                  <Option value={'EXP'}>Expedido</Option>
                  <Option value={'CAN'}>Cancelado</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectParceiro />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectTransportadoraParceira />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Placa do veículo</TextFilter>} name="placa">
                <Input maxLength={8} type="text" placeholder="Digite a placa" />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Data agendamento</TextFilter>} name="dhAgendamento">
                <RangePicker
                  style={{ width: '100%' }}
                  locale={CALENDAR_LOCALE}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
